module.exports = __webpack_public_path__ + "img/img2.cac60b94.jpg";